import React, { useEffect, useState } from 'react';
import { DATA_TYPE, FIELD_DETAILS, PROJECT_NAME, TITLE } from '../ISRConstants';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../Pages/DefineModel/model';
import {useISRContext} from "../Hooks/useISRContext";

type TextFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo?: TIndexState;
}

const FieldComponent = ({id, selectedItem, setUserProjectDataModels, userProjectDataModels, indexInfo}: TextFieldProps) => {
    const [fieldName, setFieldName] = useState<string>('');
    const {fieldUpdate, setFieldUpdate} = useISRContext();

    useEffect(() => {
        if (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) {
            setFieldName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data.fields[indexInfo?.fieldIndex ?? -1].name ?? "");
        } else {
            setFieldName(userProjectDataModels?.project.fields[indexInfo?.fieldOutsideDataModelIndex ?? -1]?.data?.name ?? "");
        }
    }, [selectedItem]);

    const updateFieldName = (fieldName: string) => {
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            if (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]) {
                    dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1].name = fieldName;
                    const field = dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1];
                    setFieldUpdate(fieldUpdate.filter((e:TField) => e.id !== field.id).concat([dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]]));
                }
            } else {
                const fieldToUpdate = newDataModels.project.fields[indexInfo?.fieldOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data) {
                    fieldToUpdate.data.name = fieldName;
                }
            }
        return newDataModels;});
    };

    const handleDataTypeChange = (value: string) => {
        setFieldName(value);
        updateFieldName(value);
    };

    return (
        <div id={id} className='cart-style-dm'>
            <label id={`${id}-title`} className='cart-title'>{FIELD_DETAILS}</label>
            <div id={`${id}-content`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-name-section`} className='tw-w-[60%] tw-pe-2'>
                    <label id={`${id}-name-label`} className='tw-text-sm tw-text-[#747593] tw-block'>
                        {TITLE}
                    </label>
                    <input 
                        id={`${id}-name-input`}
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        value={fieldName}
                        onChange={(e) => handleDataTypeChange(e.target.value)}
                        placeholder={PROJECT_NAME} 
                    />
                </div>
                <div id={`${id}-type-section`} className='tw-w-[40%] tw-ms-4'>
                    <label id={`${id}-type-label`} className='tw-text-sm tw-text-[#747593] tw-block'>
                        {DATA_TYPE}
                    </label>
                    <input 
                        id={`${id}-type-input`}
                        className="tw-rounded tw-bg-shades-of-grey-20 tw-box-border tw-w-[60%] tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        disabled={true}
                        placeholder={selectedItem?.type} 
                    />
                </div>
            </div>
        </div>
    );
}

export default FieldComponent;